import request from "@/utils/request.js"

const stock = {
    list: params => request.post("/api/Product/Stock/GetList", params),
    import: params => request.post("/api/Product/Stock/Import", params),
    export: params => request.post("/api/Product/Stock/Export", params),
    delete: params => request.get("/api/Product/Stock/Delete", { params })
}
const material = {
    list: params => request.post("/api/Product/Material/GetList", params),
    import: params => request.post("/api/Product/Material/Import", params),
    delete: params => request.get("/api/Product/Material/Delete", { params }),
    types: params => request.get("/api/Product/Material/Types", { params }),
    categorys: params => request.get("/api/Product/Material/Categorys", { params })
}
const outbound = {
    list: params => request.post("/api/Product/Outbound/GetList", params),
    import: params => request.post("/api/Product/Outbound/Import", params),
    delete: params => request.post("/api/Product/Outbound/Delete", params)
}

const purchase = {
    list: params => request.post("/api/Product/Purchase/GetList", params),
    detail: params => request.get("/api/Product/Purchase/GetInfo", { params }),
    submit: params => request.post("/api/Product/Purchase/Submit", params),
    tosale: params => request.get("/api/Product/Purchase/ToSale", { params }),
    delete: params => request.post("/api/Product/Purchase/Delete", params)
}
const presale = {
    list: params => request.post("/api/Product/Presale/GetList", params),
    detail: params => request.get("/api/Product/Presale/GetInfo", { params }),
    submit: params => request.post("/api/Product/Presale/Submit", params),
    delete: params => request.post("/api/Product/Presale/Delete", params)
}


export default {
    stock,
    material,
    outbound,
    purchase,
    presale
}